/**
 * 微信接口文档
 * https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421141115
 */
import Vue from "vue";
import request from "@/utils/request";
import toast from "@/components/yx-toast";
import { createStore } from "@/store";
import { getUserInfo, getAccid, getAppid } from "@/api/app";
Vue.use(toast);
let apiDomain =
	location.origin.indexOf("pycoding.com") == -1 ? "" : "//app.yatiku.com";
const vue = new Vue();
const wx = window.wx;
const store = createStore();
// let apiDomain = location.origin.indexOf('pycoding.com') == -1 ? '' : '//app.yatiku.com/'
export default {
	//  获取jssdk
	getJssdk(apiList, cb, url = location.href) {
		url = encodeURIComponent(url);
		let accid = localStorage.accid ? localStorage.accid : 1;
		accid = accid.length > 3 ? accid.split('_')[0] : accid; // 此处是判断是微信还是浏览器
		let obj = { url, accid };
		request(apiDomain)
			.post(`/activity/jsapiTicket?urltimer=${new Date().getTime()}`, obj)
			.then(data => {
				let signPackage = data.data;
				signPackage.debug = process.env.NODE_ENV == "production" ? false : true;
				signPackage.jsApiList = apiList;
				wx.config(signPackage);
				wx.ready(() => {
					cb();
				});
			});
	},
	//  上传一张图片（无方式可选）
	uploadImage: cb => {
		let apiList = ["chooseImage", "uploadImage"];
		let url = window.location.href;
		vue.$yxToast({
			type: "loading",
			title: "请稍候"
		});
		request()
			.post("/wx/jssdk", { url })
			.then(data => {
				vue.$yxToast.hideLoading();
				let signPackage = data.data;
				signPackage.debug = process.env.NODE_ENV == "production" ? false : true;
				signPackage.jsApiList = apiList;
				wx.config(signPackage);
				wx.ready(() => {
					wx.chooseImage({
						success: res => {
							let { localIds } = res;
							if (localIds.length != 1) {
								vue.$yxToast({
									type: "fail",
									title: "请选择一张图片"
								});
								return;
							}
							wx.uploadImage({
								localId: localIds[0], // 需要上传的图片的本地ID，由chooseImage接口获得
								isShowProgressTips: 0,
								success: res => {
									let { serverId } = res;
									vue.$yxToast({
										type: "正在上传",
										title: "请稍候"
									});
									request()
										.post("/uploadImage", { serverId })
										.then(res => {
											vue.$yxToast.hideLoading();
											if (res.status_code == "200") {
												cb(res.data.url);
											} else {
												vue.$yxToast({
													type: "fail",
													title: res.message
												});
											}
										})
										.catch(() => {
											vue.$yxToast({
												type: "请重试",
												title: res.message
											});
										});
								}
							});
						}
					});
				});
			})
			.catch(res => {
				vue.$yxToast({
					type: "请重试",
					title: res.message
				});
			});
	},
	//  微信图片预览
	previewImage(curImageSrc, imgArray) {
		this.getJssdk(["previewImage"], () => {
			wx.previewImage({
				current: curImageSrc,
				urls: imgArray
			});
		});
	},
	//  微信分享
	share(title = "", link = "", imgUrl = "", desc = "", cb = () => {}) {
		this.getJssdk(["onMenuShareTimeline", "onMenuShareAppMessage"], err => {
			wx.onMenuShareTimeline({
				title, // 分享标题
				link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
				imgUrl, // 分享图标
				success: res => {
					cb(res);
				}
			});
			wx.onMenuShareAppMessage({
				title, // 分享标题
				desc, // 分享描述
				link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
				imgUrl, // 分享图标
				success: res => {
					cb(res);
				}
			});
		});
	},
	//  微信支付
	// pay(data, successCb = () => {}, failCb = () => {}, cancelCb = () => {}, url) {
	// 	this.getJssdk(
	// 		["chooseWXPay"],
	// 		() => {
	// 			wx.chooseWXPay({
	// 				...data,
	// 				success: res => {
	// 					vue.$yxToast("支付成功");
	// 					successCb(res);
	// 				},
	// 				fail: res => {
	// 					vue.$yxToast("支付失败");
	// 					failCb(res);
	// 				},
	// 				cancel: res => {
	// 					vue.$yxToast("支付已取消");
	// 					cancelCb(res);
	// 				}
	// 			});
	// 		},
	// 		url
	// 	);
	// },
	address() {
		return new Promise((resolve, reject) => {
			this.getJssdk(["editAddress"], () => {
				wx.openAddress({
					success: address => {
						console.log("获取地址成功", address);
						resolve(address);
					},
					fail: error => {
						console.log("获取地址失败", error);
						reject(error);
					}
				});
			});
		});
	},
	// closewindow
	close() {
		this.getJssdk(["closeWindow"], () => {
			wx.closeWindow();
		});
	},
	getAccId(query, code) {
		return new Promise((resolve, reject) => {
			let { activityId, accId } = query;
			let fn =
				(!accId && activityId) || (accId && activityId === "0")
					? getAccid(activityId)
					: getAppid(accId.indexOf('_') != -1 ? accId.split('_')[0] : accId);
			fn.then(
				result => {
					let { accid, appid } = result.data;
					localStorage.setItem("appId", appid);
					store.commit("setappParam", { accid, appid });
					getUserInfo(code || null, accid).then(
						res => {
							if (res.code == 404) {
								vue.$yxToast(res.message);
								reject(result.data);
							} else {
								store.commit("setUserInfo", res.data);
								store.dispatch("userInfo");
								localStorage.setItem('buriedPoint', JSON.stringify(res.data));
								vue.$nextTick(() => {
									resolve(result.data);
								});
							}
						},
						error => {
							console.log(error);
							vue.$yxToast("无法连接服务器");
						}
					);
				},
				error => {
					console.log(error);
					vue.$yxToast("无法连接服务器,请刷新重试");
				}
			);
		});
	},

	//  微信支付
	pay(data, successCb = () => {}, failCb = () => {}, cancelCb = () => {}, url) {
		this.getJssdk(
			["chooseWXPay"],
			() => {
				wx.chooseWXPay({
					...data,
					success: res => {
						vue.$yxToast("支付成功");
						successCb(res);
					},
					fail: res => {
						vue.$yxToast("支付失败");
						failCb(res);
					},
					cancel: res => {
						vue.$yxToast("支付已取消");
						cancelCb(res);
					}
				});
			},
			url
		);
	},

	initAudio() {
		return new Promise((resolve, reject) => {
			this.getJssdk(
				[
					"startRecord",
					"stopRecord",
					"playVoice",
					"uploadVoice",
					"onVoiceRecordEnd",
					"stopVoice",
					"onVoicePlayEnd"
				],
				() => {
					resolve();
				}
			);
		});
	}
};



// WEBPACK FOOTER //
// ./src/utils/wxMethods.js